export const GET_GESTIONE_FILE_AUDIO_DATA =
  "GET_GESTIONE_FILE_AUDIO_DATA_AND_LOADING";
export const EXPORT_FILE_AUDIO_LOADING = "EXPORT_FILE_AUDIO_LOADING";
export const DOWNLOAD_FILE_AUDIO_LOADING = "DOWNLOAD_FILE_AUDIO_LOADING";
export const CREATE_UPDATE_DELETE_FILE_AUDIO =
  "CREATE_UPDATE_DELETE_FILE_AUDIO";
export const GET_CREATE_FILE_AUDIO_DATA = "GET_CREATE_FILE_AUDIO_DATA";
export const GET_CURRENT_FILE_AUDIO = "GET_CURRENT_FILE_AUDIO";
